import { render } from "./TrailerPage.vue?vue&type=template&id=77128be1&scoped=true"
import script from "./TrailerPage.vue?vue&type=script&lang=js"
export * from "./TrailerPage.vue?vue&type=script&lang=js"

import "./TrailerPage.vue?vue&type=style&index=0&id=77128be1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77128be1"]])

export default __exports__